export const CACHED_STATUS_CODE = 304;
export const CACHED_STATUS_TEXT = '304 Cached by axios-cache-interceptor';
